import { callApi } from './api';

import { ApiResult } from '@/types/api';
import { PerformanceRecordRequest } from '@/types/performanceRecord';

export const createPerformanceRecord = async (
  childID: number,
  requestBody: PerformanceRecordRequest
): Promise<ApiResult<boolean>> => {
  const { status, result } = await callApi<boolean>(
    `children/${childID}/performance-records`,
    'POST',
    undefined,
    requestBody,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
